module.exports = __webpack_public_path__ + "e6ae1d42227c4188c4f9efa29315e5af.png";